// Test IDs for the consultation-request form, shared by the modal
// (ConsultationDialog) and the standalone /reach-out page.
// See ./index.js for the recipe to add a new feature file.

export const REACH_OUT = {
	dialog: 'consultation-dialog',
	success: 'consultation-success',
	form: 'consultation-form',
	nameInput: 'consult-name',
	emailInput: 'consult-email',
	phoneInput: 'consult-phone',
	preferredContactSelect: 'consult-preferred-contact',
	preferredLanguageSelect: 'consult-preferred-language',
	isAdultCheckbox: 'consult-is-adult',
	underageNote: 'consult-underage-note',
	timeInput: 'consult-time',
	reasonInput: 'consult-reason',
	submitButton: 'consult-submit',
};
